/* HM Header (sections/hm-header-a.liquid).
   Desktop (option C): moves the Services / Insurance / Support nav into the utility strip and, on pages that render
   the Wellness banner (homepage, until dismissed), rebuilds its text + image as the strip's azure tab (the banner
   itself is hidden on desktop by CSS; phones keep it). Lines the strip and the category row up with the logo (left)
   and Cart (right) via --hma-l / --hma-r.
   Below 990px: the header's menu button opens #HmaMenu (phone menu M1) instead of the theme drawer. While it is open,
   html.hma-open locks page scroll and tucks the homepage banner away; the menu's top edge is re-measured after that. */
(function () {
  if (window.__hmaInit) return;
  window.__hmaInit = true;
  var mq = window.matchMedia('(max-width: 989px)');
  var panel = null, summary = null, lastFocus = null;
  var SVG = 'http://www.w3.org/2000/svg';

  function svgPath(cls, d) {
    var s = document.createElementNS(SVG, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    if (cls) s.setAttribute('class', cls);
    var p = document.createElementNS(SVG, 'path');
    p.setAttribute('d', d);
    s.appendChild(p);
    return s;
  }

  function buildStrip() {
    var strip = document.getElementById('HmaStrip');
    if (!strip) return;
    var links = strip.querySelector('.hma-strip__links');
    var nav = document.querySelector('.section-header .header__icons > nav.header__inline-menu');
    if (nav && links) links.appendChild(nav);
    var b = document.querySelector('.section-header a.hm-nd-url-container');
    var annBox = strip.querySelector('.hma-strip__ann');
    if (!b || !annBox || document.documentElement.classList.contains('hm-banner-dismissed')) return;
    var d = b.querySelector('.hm-nd-description');
    var txt = d ? d.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!txt) return;
    var box = document.createElement('div');
    box.className = 'hma-ann';
    var a = document.createElement('a');
    a.className = 'hma-ann__link';
    a.href = b.getAttribute('href') || '/pages/wellness';
    var t = document.createElement('span');
    var m = txt.match(/^(New!)\s*(.*)$/);
    if (m) {
      var bb = document.createElement('b');
      bb.textContent = m[1];
      t.appendChild(bb);
      t.appendChild(document.createTextNode(' ' + m[2]));
    } else {
      t.textContent = txt;
    }
    a.appendChild(t);
    var src = b.querySelector('.hm-nd-image img');
    if (src) {
      var im = document.createElement('img');
      im.src = src.currentSrc || src.src;
      im.alt = '';
      im.width = 76;
      im.height = 24;
      a.appendChild(im);
    }
    a.appendChild(svgPath('hma-ann__go', 'M9 6l6 6-6 6'));
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'hma-ann__x';
    x.setAttribute('aria-label', 'Close');
    x.appendChild(svgPath('', 'M7 7l10 10M17 7L7 17'));
    x.addEventListener('click', function () {
      document.documentElement.classList.add('hm-banner-dismissed');
      try { sessionStorage.setItem('hm_wellness_banner_dismissed', 'true'); } catch (e) {}
      if (box.parentNode) box.parentNode.removeChild(box);
    });
    box.appendChild(a);
    box.appendChild(x);
    annBox.appendChild(box);
  }

  function alignRow() {
    if (mq.matches) return false;
    var logo = document.querySelector('.section-header .header__heading-link');
    var cart = document.querySelector('.section-header .header__icon--cart');
    if (!logo || !cart) return false;
    var changed = false;
    var els = [document.querySelector('.section-header .menu-main-one'), document.getElementById('HmaStrip')];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!el) continue;
      var r = el.getBoundingClientRect();
      var l = Math.max(0, Math.round(logo.getBoundingClientRect().left - r.left)) + 'px';
      var rr = Math.max(0, Math.round(r.right - cart.getBoundingClientRect().right)) + 'px';
      if (el.style.getPropertyValue('--hma-l') !== l || el.style.getPropertyValue('--hma-r') !== rr) changed = true;
      el.style.setProperty('--hma-l', l);
      el.style.setProperty('--hma-r', rr);
    }
    return changed;
  }
  function alignAndRelayout() { if (alignRow()) window.dispatchEvent(new Event('resize')); }

  function headerBottom() {
    var h = document.querySelector('.section-header sticky-header') || document.querySelector('.section-header');
    return h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
  }
  function setTop() { if (panel && !panel.hidden) panel.style.setProperty('--hma-top', headerBottom() + 'px'); }
  function show(lvl) {
    var lvls = panel.querySelectorAll('.hma-m1__lvl');
    for (var i = 0; i < lvls.length; i++) lvls[i].hidden = lvls[i].getAttribute('data-lvl') !== lvl;
    panel.scrollTop = 0;
    var cur = panel.querySelector('[data-lvl="' + lvl + '"]');
    var f = cur && cur.querySelector(lvl === 'root' ? '.hma-row' : '.hma-back');
    if (f && f.focus) { try { f.focus({ preventScroll: true }); } catch (e) {} }
  }
  function open() {
    lastFocus = document.activeElement;
    document.documentElement.classList.add('hma-open');
    panel.hidden = false;
    setTop();
    show('root');
    summary.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { setTop(); requestAnimationFrame(setTop); });
  }
  function close(restore) {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    document.documentElement.classList.remove('hma-open');
    summary.setAttribute('aria-expanded', 'false');
    if (restore && lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function init() {
    try { buildStrip(); } catch (e) {}
    alignAndRelayout();
    window.addEventListener('load', alignAndRelayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(alignAndRelayout);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(alignAndRelayout, 80); });

    panel = document.getElementById('HmaMenu');
    summary = document.querySelector('header-drawer summary');
    if (!panel || !summary) return;
    document.body.appendChild(panel);
    summary.setAttribute('aria-controls', 'HmaMenu');
    summary.setAttribute('aria-expanded', 'false');

    /* capture phase on document: runs before the theme drawer's own summary listener */
    document.addEventListener('click', function (e) {
      var s = e.target && e.target.closest ? e.target.closest('header-drawer summary') : null;
      if (!s || !mq.matches) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (panel.hidden) open(); else close(true);
    }, true);

    panel.addEventListener('click', function (e) {
      var go = e.target.closest('[data-go]');
      if (go) { show(go.getAttribute('data-go')); return; }
      if (e.target.closest('[data-back]')) { show('root'); return; }
      var gr = e.target.closest('button.hma-gr');
      if (gr) {
        var was = gr.getAttribute('aria-expanded') === 'true';
        var openOnes = gr.closest('.hma-m1__lvl').querySelectorAll('button.hma-gr[aria-expanded="true"]');
        for (var i = 0; i < openOnes.length; i++) {
          openOnes[i].setAttribute('aria-expanded', 'false');
          if (openOnes[i].nextElementSibling) openOnes[i].nextElementSibling.hidden = true;
        }
        if (!was) { gr.setAttribute('aria-expanded', 'true'); if (gr.nextElementSibling) gr.nextElementSibling.hidden = false; }
        return;
      }
      if (e.target.closest('a[href]')) close(false);
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(true); });
    window.addEventListener('resize', function () { if (!mq.matches) close(false); else setTop(); });
    window.addEventListener('scroll', setTop, { passive: true });
    window.addEventListener('pageshow', function () { close(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
